import { isGlobalFeatureEnabled } from 'owa-feature-flags';

/**
 * Checks if the Event Draft Assistant (BizChat sidepane) experience is enabled.
 * This routes calendar draft requests to the BizChat sidepane instead of inline skittle.
 */
export function isEventDraftAssistantEnabled(): boolean {
    return isGlobalFeatureEnabled('time-copilot-ida-draft-assistant');
}

/**
 * Checks if the Event Draft Assistant is enabled for existing events.
 * When enabled, the button is shown immediately on form open rather than
 * only when the editor is empty.
 */
export function isEventDraftAssistantEnabledForExistingEvents(): boolean {
    return isGlobalFeatureEnabled('time-copilot-ida-draft-assistant');
}

/**
 * Checks if the autodraft button in the old DraftCopilotPlugin should be enabled.
 * Returns false when the new DraftAgendaPlugin handles the button instead.
 */
export function isAutodraftButtonEnabled(): boolean {
    return (
        isGlobalFeatureEnabled('time-copilot-ida-autodraft-button') &&
        !isEventDraftAssistantEnabled()
    );
}
